// extracted by mini-css-extract-plugin
export const outside = "football-module--outside--4MSuA";
export const index = "football-module--index--1uk2x";
export const out = "football-module--out--3dD-R";
export const outer = "football-module--outer--3Hhl-";
export const card = "football-module--card--2gOP4";
export const logo = "football-module--logo--3M1nb";
export const topRow = "football-module--top-row--XVs68";
export const bottomRow = "football-module--bottom-row--1YZIc";
export const imageSection = "football-module--image-section--2rYVs";
export const tabsSection = "football-module--tabs-section--1Dqzm";
export const tableLogo = "football-module--table-logo--KuDAd";
export const table = "football-module--table--3eFwA";
export const tableContainer = "football-module--table-container--1JkfI";
export const tabContainer = "football-module--tab-container--DdUb1";
export const score = "football-module--score--gCuuj";